import _BaseAPIService from "../_BaseAPIService";

const instance =  _BaseAPIService.instance;

const RestroPayment = {
    Graceupdate : async (payload) => {
        try{
            const response = await instance.post("/restropayment/update-grace-period",payload);
            return response.data;
        }
        catch(error){
            console.error(error);
            throw error;
        }
    },

    AddPayment : async (payload) => {
        try {
            const response = await instance.post("/restropayment/add-payment",payload);
            return response.data;
        }catch(error) {
            console.error(error);
            throw error;
        }
    }
};

export default RestroPayment;